import type { JSX } from 'react';
import { ErrorState } from '@/components/ui/error-state.js';
import { ApiError } from '@/lib/api/client.js';

/**
 * Limite d'erreur de route (`errorComponent` de `createRootRoute`) — `02` §0 :
 * « erreurs techniques : message en français courant + détail technique
 * repliable ; jamais de page blanche. »
 */
export interface RouteErrorBoundaryProps {
  error: unknown;
  reset?: () => void;
}

function toDetail(error: unknown): string | undefined {
  if (error instanceof ApiError) {
    return error.detail;
  }
  if (error instanceof Error) {
    return error.stack ?? error.message;
  }
  return typeof error === 'string' ? error : undefined;
}

export function RouteErrorBoundary({ error, reset }: RouteErrorBoundaryProps): JSX.Element {
  const message =
    error instanceof ApiError
      ? error.message
      : 'Une erreur technique est survenue. Réessayez ; si le problème persiste, consultez le journal.';

  return (
    <div className="flex min-h-[60vh] items-center justify-center bg-background p-6">
      <ErrorState
        message={message}
        detail={toDetail(error)}
        onRetry={reset}
        className="w-full max-w-xl"
      />
    </div>
  );
}
